import React from 'react';

function Favorites() {
  return (
    <div className="page">
      <h2>Favorites</h2>
      <p className="text-muted">Favorites coming soon.</p>
    </div>
  );
}

export default Favorites;
